import { toast, ToastOptions } from 'react-toastify'
import { colors } from '../theme/cssVariables'
import { Box, Text } from '@chakra-ui/react'

const defaultOptions: ToastOptions = {
  position: 'bottom-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  style: {
    background: colors.colorB7,
    color: colors.colorB1,
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
}

type ToastMessage = string | { title: string; body: string }

const ToastContent = ({ title, body }: { title: string; body: string }) => (
  <Box>
    <Text fontWeight="bold" mb={1}>
      {title}
    </Text>
    <Text>{body}</Text>
  </Box>
)

const renderToastContent = (message: any) => {
  if (typeof message === 'string') {
    return message
  }
  if (typeof message === 'object' && 'title' in message && 'body' in message) {
    return <ToastContent title={message.title} body={message.body} />
  }
  return message
}

export const showToast = {
  success: (message: any, options?: ToastOptions) => {
    toast.success(renderToastContent(message), {
      ...defaultOptions,
      ...options,
    })
  },
  error: (message: ToastMessage, options?: ToastOptions) => {
    toast.error(renderToastContent(message), {
      ...defaultOptions,
      ...options,
    })
  },
  info: (message: ToastMessage, options?: ToastOptions) => {
    toast.info(renderToastContent(message), {
      ...defaultOptions,
      ...options,
    })
  },
  warning: (message: ToastMessage, options?: ToastOptions) => {
    toast.warning(renderToastContent(message), {
      ...defaultOptions,
      ...options,
    })
  },
  loading: (message: ToastMessage, options?: ToastOptions) => {
    return toast.loading(renderToastContent(message), {
      ...defaultOptions,
      ...options,
    })
  },
  dismiss: (toastId?: string | number) => {
    toast.dismiss(toastId)
  },
  update: (toastId: string | number, message: ToastMessage, options?: ToastOptions) => {
    toast.update(toastId, {
      render: renderToastContent(message),
      ...defaultOptions,
      ...options,
    })
  },
}
